import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
export default function SalesOverview() {
  const data = [
    { month: "Jan", income: 40, expenses: 80 },
    { month: "Feb", income: 30, expenses: 70 },
    { month: "Mar", income: 45, expenses: 60 },
    { month: "Apr", income: 80, expenses: 40 },
    { month: "May", income: 85, expenses: 35 },
    { month: "Jun", income: 90, expenses: 30 },
    { month: "Jul", income: 80, expenses: 45 },
    { month: "Aug", income: 100, expenses: 20 },
    { month: "Sep", income: 78, expenses: 55 },
    { month: "Oct", income: 85, expenses: 40 },
    { month: "Nov", income: 20, expenses: 25 },
    { month: "Dec", income: 78, expenses: 32 },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="chart-tooltip">
          <p>
            Income <span>${payload[0].value}K</span>
          </p>
          <p>
            Expenses <span>${payload[1].value}K</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <Card className="sales-card h-100">
        <div className="sales-header">
          <h6>Sales Overview</h6>

          <div className="sales-actions">
            <Dropdown>
              <Dropdown.Toggle className="dropdown-btn">
                All Departments
                <KeyboardArrowDownIcon className="fs-6"></KeyboardArrowDownIcon>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>UI/UX Designer</Dropdown.Item>
                <Dropdown.Item>HR Manager</Dropdown.Item>
                <Dropdown.Item>Junior Tester</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown>
              <Dropdown.Toggle className="date-btn">
                <FiCalendar className="me-1" /> Today
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>This Month</Dropdown.Item>
                <Dropdown.Item>This Week</Dropdown.Item>
                <Dropdown.Item>Today</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <div className="sales-body">
          <div className="sales-info">
            <div className="legend">
              <span className="income-dot"></span> Income
              <span className="expense-dot ms-3"></span> Expenses
            </div>

            <p className="update-text">Last Updated at 11:30PM</p>
          </div>

          <div className="chart-box">
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={data} barGap={4}>
                <CartesianGrid
                  stroke="#f0f0f0"
                  strokeDasharray="3 3"
                  vertical={false}
                />

                <XAxis
                  dataKey="month"
                  axisLine={false}
                  tick={{ fontSize: 12, fill: "#546e7a" }}
                />

                <YAxis
                  axisLine={false}
                  tick={{ fontSize: 12, fill: "#546e7a" }}
                />

                <Tooltip
                  content={<CustomTooltip />}
                  cursor={{ fill: "rgba(245, 165, 0, 0.1)" }}
                />

                <Bar
                  dataKey="expenses"
                  fill="#f3f4f6"
                  radius={[6, 6, 0, 0]}
                  barSize={
                    28}
                />

                <Bar
                  dataKey="income"
                  fill="#ff6b1a"
                  radius={[6, 6, 0, 0]}
                  barSize={28}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </Card>

      <style>{`

.sales-card{

border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);

}

.sales-header{
display:flex;
justify-content:space-between;
align-items:center;
padding:15px;
border-bottom:1px solid #eee;
}

.sales-header h6{
font-size:16px;
font-weight:600;
margin:0;
}

.sales-actions{
display:flex;
gap:10px;
}

.dropdown-btn{
background:#fff;
border:none;
font-size:13px;
color:#000;
}

.date-btn{
border:1px solid #ddd;
background:#fff;
font-size:13px;
color:#000;
}

.sales-body{
padding:15px;
}

.sales-info{
display:flex;
justify-content:space-between;
align-items:center;
margin-bottom:10px;
}

.legend{
font-size:13px;
color:#000;
}

.income-dot{
width:10px;
height:10px;
background:#ff6a00;
display:inline-block;
border-radius:50%;
margin-right:6px;
}

.expense-dot{
width:10px;
height:10px;
background:#dcdcdc;
display:inline-block;
border-radius:50%;
margin-right:6px;
}

.update-text{
  font-size:12px;
  color:#777;
}

.chart-tooltip {
  background: #1f2937;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
}

.chart-tooltip p {
  margin: 0;
  line-height: 1.4;
}

.chart-tooltip span {
  float: right;
  font-weight: 600;
}


.chart-tooltip{
background:#1e2a3b;
padding:10px 15px;
border-radius:8px;
color:#fff;
font-size:13px;
}

.chart-tooltip p{
margin:0;
display:flex;
justify-content:space-between;
gap:20px;
}

.chart-tooltip span{
font-weight:600;
}

`}</style>
    </>
  );
}
